// extracted by mini-css-extract-plugin
export default {"largeDeviceMinWidth":"1201","mediumDeviceMinWidth":"721","mediumDeviceMaxWidth":"1200","smallDeviceMaxWidth":"720","transitionTime":".5"};